<template>
  <VanPopup v-model:show="show" position="bottom">
    <VanPicker
      :columns="columns"
      @cancel="show = false"
      @confirm="onConfirm"
      :confirm-button-text="t('Buttons.momentSave')"
      :cancel-button-text="t('Buttons.cancel')"
    />
  </VanPopup>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { PickerConfirmEventParams } from "vant";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  showAll: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update:show", "confirm"]);

const show = computed({
  get: () => props.show,
  set: (value) => {
    emit("update:show", value);
  },
});

const store = useGalGameEditor();
const { t } = useI18n();

const columns = computed(() => {
  let list = [];
  if (props.showAll)
    list.push({
      text: t(`Buttons.all`),
      value: 0,
    });
  list.push(
    ...Object.values(store.characterIdMap).map((item) => {
      let text = item.name;
      let name = item.name ? `（${item.name}）` : "";
      text = `${t(`game.role.${item.role}`)}${name}`;
      return { text, value: item.id };
    })
  );
  return list;
});
const onConfirm = (value: PickerConfirmEventParams) => {
  const targetCharacterId = value.selectedValues[0] as number;
  emit("confirm", targetCharacterId);
};
</script>
